import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Rating,
  Slider,
  Typography,
} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { resetFilters, setFilterState } from '../features/filter/filterSlice';
import { useDispatch } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { SearchInput } from './SearchInput';
import { colors } from '../styles/colors';
import { roundPrice, roundPriceTransfers } from '../helpers/RoundPrice';
import { useAppSelector } from '../hooks/useAppReducer';
import { setFindButtonClick } from '../features/findButtonClicked/findButtonClicked';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { sortRoom } from '../helpers/sortRoom';
import { calculatePerPersonPrice } from '../helpers/calculatePerPersonPrice';
import { isDiscountValidDate } from '../helpers/isDiscountValidDate';
import { formatPrice } from '../helpers/formatPrice';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { ReactComponent as HolidayTypeSearchIcon } from "../assets/icons/HolidayTypeSearchIcon.svg";
import { ReactComponent as RegionSearchIcon } from "../assets/icons/RegionSearchIcon.svg"
import { ReactComponent as RatingStarSearchIcon } from "../assets/icons/RatingStarSearchIcon.svg"
import { ReactComponent as MaxPriceSearchIcon } from "../assets/icons/MaxPriceSearchIcon.svg"
import useWindowWidth from '../hooks/useWindowWidth';
interface ModalProp {
  getPosition: (p: any, b: boolean, f: boolean) => void;
  setIsClickedFilters: any;
  isClickedFilters: any;
  viewMode?: string
}

export const FilterComponent = ({ getPosition, isClickedFilters, setIsClickedFilters, viewMode }: ModalProp) => {
  //! States
  const { filters } = useAppSelector((state) => state.filters);
  const { holidayPackage, filteredHolidayPackage, holidayTypes, filterCounts, regionCounts, regionTypes } = useAppSelector(
    (state) => state.holidayPackage
  );
  const { findButtonClick } = useAppSelector((state: any) => state.findButtonClicked)
  const [showAll, setShowAll] = useState<any>({
    region: false,
    hotels: false
  })
  const { flightRoom } = useAppSelector((state) => state.flightRoom);


  // For Expand
  const [openHoliday, setOpenHoliday] = useState(true);
  const [openRegion, setOpenRegion] = useState(true);
  const [openRating, setOpenRating] = useState(true);
  const [openPrice, setOpenPrice] = useState(true);

  //! Hooks

  //! Hooks
  const [hotelNameSearchText, setHotelNameSearchText] = useState(filters.hotelName);
  const [resultAvailableHotelRatings, setResultAvailableHotelRatings] = useState([])
  // const [pricePerPerson, setPricePerPerson] = useState(filters.price);
  const [pricePerPerson, setPricePerPerson] = useState<any>(Array.isArray(filters.price) ? filters.price : [0, 10500]);
  const [price, setPrice] = useState({ low: 0, high: 0 });
  //! Variables
  const dispatch = useDispatch();
  const packageResults = filteredHolidayPackage?.Packages?.results?.length;
  const totalGuests = Number(flightRoom.searchCriteria.adults + flightRoom.searchCriteria.childrens);
  const signForPricing = process.env.REACT_APP_CURRENCY_SYMBOL
  const windowWidth = useWindowWidth();
  const minPackage = useMemo(() => {
    return holidayPackage?.Packages?.results?.map((data: any, index: number) => {
      const getRooms = sortRoom(data.SearchResult, filters)
      // const tPrice = data.SearchResult.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt ? (parseFloat(data.SearchResult.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt) * parseFloat(data.SearchResult.transfer?.pagedata[0]?.Transfer?.exchange_rate)) : 0
      const tPrice: any = data.SearchResult.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt ? parseFloat(data.SearchResult.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt) : 0
      const transferPrice = roundPriceTransfers(tPrice, flightRoom.searchCriteria.isAdditionalTransferAmountAdd, totalGuests, flightRoom, data.SearchResult.transfer?.pagedata[0]?.Transfer?.exchange_rate || 0)
      const transfer_add = !flightRoom?.searchCriteria?.destination?.default_transfer ? transferPrice : 0
      let price: any = 0
      if (getRooms.length > 0) {
        getRooms.map((f: any) => {
          price = price + Number(f.total_package)
          return <></>
        })
      }

      const totalPrice = (price) / totalGuests

      let finalPrice;
      if (flightRoom?.searchCriteria?.destination?.discountPrice?.isDiscountUK
        && process.env.REACT_APP_PROJECT_COUNTRY === "uk"
        && isDiscountValidDate()) {
        finalPrice = Number(formatPrice(String(calculatePerPersonPrice(roundPrice(totalPrice), totalGuests))));
      } else if (flightRoom?.searchCriteria?.destination?.discountPrice?.isDiscountIE
        && process.env.REACT_APP_PROJECT_COUNTRY === "ie"
        && isDiscountValidDate()) {

        finalPrice = Number(formatPrice(String(calculatePerPersonPrice(roundPrice(totalPrice), totalGuests))));
      } else {
        finalPrice = Number(roundPrice(String(totalPrice)));
      }
      return finalPrice;
    });

  }, [holidayPackage?.Packages?.results, totalGuests]);


  useEffect(() => {
    let ratings: any = []
    holidayPackage?.Packages?.results
      ?.map((item: any) => item.HotelInfo)
      .filter((item: any) => {
        if (item?.hotel_rating) {
          let value = 0
          if (item.hotel_classification === "0") {
            value = Number(item.hotel_rating)
          } else {
            value = item?.hotel_classification === "2" ? Number(item.hotel_rating) === 5 ? 5 : Number(item.hotel_rating) + 0.5 : Number(item.hotel_rating)
          }

          if (!ratings.includes(value)) {
            ratings.push(value)
          }
        }
        return item
      })
    setResultAvailableHotelRatings(ratings.sort((a: number, b: number) => b - a))
  }, [holidayPackage?.Packages?.results])

  useEffect(() => {
    const price = {
      low:
        minPackage?.length !== 0
          ? minPackage?.reduce((min: number, current: number) => {
            return min > current ? current : min;
          })
          : 0,
      high:
        minPackage?.length !== 0
          ? minPackage?.reduce((max: number, current: number) => {
            return max > current ? max : current;
          })
          : 0,
    };
    setPrice(price);
  }, [minPackage]);

  useEffect(() => {
    if (isClickedFilters) {
      getPosition(filteredHolidayPackage, false, true)
    }
  }, [filteredHolidayPackage, isClickedFilters])

  //! Functions
  const handleReset = () => {
    dispatch(setIsClickedFilters(true))
    dispatch(resetFilters());
    setHotelNameSearchText('');
    dispatch(setFilterState({
      holidayType: [],
      starRating: [],
      hotelName: '',
      sorting: 'Popularity',
      regionType: [],
      price: [price?.low, price?.high]
    }))
    setPricePerPerson([price?.low, price?.high]);
  };

  useEffect(() => {
    if (!findButtonClick) {
      setPricePerPerson(filters.price);
      dispatch(setFilterState({ ...filters, price: filters.price }))
    }
  }, [filters.price, findButtonClick])

  useEffect(() => {
    if (findButtonClick) {
      setShowAll({
        region: false,
        hotels: false
      })
      setPricePerPerson([price.low ? price.low : 0, price?.high || 10500])
      dispatch(setFilterState({ ...filters, price: [price.low ? price.low : 0, price?.high || 10500] }))
    }
  }, [findButtonClick, price.low, price?.high])

  const handleChangeHolidayTypeFilter = (e: any) => {
    dispatch(setIsClickedFilters(true))
    const holidayTypes: any = [...filters.holidayType];

    if (e.target.checked) {
      holidayTypes.push(e.target.value);
    } else {
      holidayTypes.splice(holidayTypes.indexOf(e.target.value), 1);
    }

    dispatch(setFilterState({ ...filters, holidayType: holidayTypes }));
  };

  const handleChangeRegionTypeFilter = (e: any) => {
    dispatch(setIsClickedFilters(true))
    const regionTypes: any = [...filters.regionType];
    if (e.target.checked) {
      regionTypes.push(e.target.value);
    } else {
      regionTypes.splice(regionTypes.indexOf(e.target.value), 1);
    }
    dispatch(setFilterState({ ...filters, regionType: regionTypes }));
  };

  const handleChangeRating = (e: any) => {
    dispatch(setIsClickedFilters(true))
    let ratings = [...filters.starRating];

    if (e.target.checked) {
      ratings.push(Number(e.target.value));
    } else {
      ratings = ratings.filter((item) => item !== Number(e.target.value));
    }

    dispatch(setFilterState({ ...filters, starRating: ratings }));
  };

  const handleHotelNameSearchChange = (value: any) => {
    dispatch(setIsClickedFilters(true))
    if (value) {
      setHotelNameSearchText(value);
    } else {
      setHotelNameSearchText(value);
      dispatch(setFilterState({ ...filters, hotelName: '' }));
    }
  };

  const handleChangeShowAllFilters = (name: any) => {
    setShowAll({
      ...showAll,
      [name]: !showAll[name]
    })
  }

  const [listWidth, setListWidth] = useState("285px");

  // useEffect(() => {

  //   if (viewMode === "list" && windowWidth <= 1024) {
  //     setListWidth("210px");

  //   } else if (viewMode === "list" && windowWidth > 1024 && windowWidth <= 1037) {
  //     const baseBreakpoint = 1024;
  //     const baseWidth = 194; // width at 1024
  //     const step = 2;

  //     const calculatedWidth =
  //       baseWidth + (windowWidth - baseBreakpoint) * step;

  //     setListWidth(`${calculatedWidth}px`);

  //   } else if (viewMode === "list" && windowWidth >= 1037 && windowWidth < 1110) {
  //     const startWidthAt = 1037;
  //     const baseWidth = 220;
  //     const stepWindow = 10; // every 10px
  //     const stepWidth = 10;  // increase by 10px

  //     const stepsPassed = Math.floor(
  //       (windowWidth - startWidthAt) / stepWindow
  //     );

  //     const calculatedWidth =
  //       baseWidth + stepsPassed * stepWidth;

  //     setListWidth(`${calculatedWidth}px`);

  //   } else {
  //     setListWidth("285px");
  //   }

  // }, [viewMode, windowWidth])


  return (
    <Box className='main_filterComponent'>
      {/* <Box
        display='flex'
        justifyContent='space-between'
        height={{ lg: '56px', sm: '40px', xs: '30px' }}
        alignItems='center'
        p='0 20px'
        bgcolor={{ lg: colors.basics.lightmain, md: 'none' }}
      >
        <Typography variant='body1' fontWeight={600} mt={{ lg: '0px', md: '20px' }}>
          Filter
        </Typography>
        <Button
          disableRipple={true}
          variant='text'
          sx={{
            fontSize: '13px',
            fontWeight: 500,
            display: { lg: 'flex', xs: 'none' },
            p: 0,
          }}
          onClick={handleReset}
        >
          Reset all
        </Button>
      </Box> */}
      <Box >
        {/* <Box display={{ lg: 'flex', xs: 'none' }}>
          <Typography color={colors.grey[30]} p='22px 0 20px'>
            {packageResults || 0} Results
          </Typography>
        </Box>{' '} */}
        <div hidden={window.innerWidth > 576 ? regionTypes?.length <= 1 : true}>
          <Box mb='10px' /* 🔥 ADD ONLY THESE LINES */
            // minWidth={listWidth}
            // maxWidth={listWidth}
            // flexShrink={0}
            // mr="auto" 
            border={{ lg: `1px solid ${colors.grey[30]}`, borderRadius: "10px", md: 'none' }} padding={"19px 24px 19px 24px"} bgcolor={colors.basics.white}>
            {/* <FormControl component='fieldset' variant='standard'> */}
            <Box display="flex" alignItems="center" mb="10px" flexDirection="row" justifyContent="space-between">
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="subtitle1" fontWeight={700} fontFamily={"Raleway"} fontSize={"16px"}>
                  Region
                </Typography>

                {/* Location Icon (same as screenshot) */}
                {/* <RegionSearchIcon /> */}
              </Box>

              {/* Arrow Icon (collapse/expand) */}
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                {openRegion ? (
                  <ExpandLessIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenRegion(false)} />
                ) : (
                  <ExpandMoreIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenRegion(true)} />
                )}
              </Box>
            </Box>
            {openRegion && (<FormGroup
              sx={{
                display: 'flex',
                flexDirection: { md: 'col', xs: 'row' },
                '& label': {
                  flex: { lg: '0 0 100%', sm: '0 0 48%', xs: '0 0 100%' },
                  alignItems: 'flex-start',
                },
                '& .MuiFormControlLabel-root .MuiFormControlLabel-label': {
                  mt: '2px !important',
                  fontSize: '14px !important',
                  lineHeight: '140% !important',
                },
                ml: '10px',
                '& .MuiButtonBase-root': {
                  padding: '0',
                  mr: '15px',
                  mb: '5px',
                },
              }}
            >
              {/* {regionTypes?.slice(0, !showAll.region ? 5 : regionTypes.length)?.map((place, index) => {
                  return (
                    <FormControlLabel
                      key={index}
                      control={<Checkbox name={place} />}
                      label={place.replace(/&amp;/g, '&') + " (" + (regionCounts[place] || 0) + ")"}
                      value={place}
                      checked={filters.regionType.includes(place)}
                      onChange={handleChangeRegionTypeFilter}
                    />
                  );
                })} */}

              {regionTypes?.slice(0, !showAll.region ? 5 : regionTypes.length)?.map((place, index) => {
                return ((regionCounts[place])) > 0 &&
                  <FormControlLabel
                    key={index}
                    control={<Checkbox name={place} sx={{
                      mr: "2px !important",   // reduces default right margin
                    }} />}
                    label={place.replace(/&amp;/g, '&') + " (" + (regionCounts[place] || 0) + ")"}
                    value={place}
                    checked={filters.regionType.includes(place)}
                    onChange={handleChangeRegionTypeFilter}
                    sx={{ fontSize: '14px', fontWeight: '400', fontFamily: 'Raleway', gap: '5px', alignItems: 'center', }}
                  />
              })}

            </FormGroup>)}
            {openRegion && regionTypes?.length > 5 && (!showAll.region ?
              <Box sx={{
                '& .MuiButton-endIcon>*:nth-of-type(1)': {
                  fontSize: '25px',
                },
                '& .MuiButton-endIcon': {
                  marginLeft: 0,
                }

              }}> <Button
                sx={{ justifyContent: "left", fontSize: "14px", p: 0, whiteSpace: 'nowrap' }}
                onClick={() => {
                  handleChangeShowAllFilters("region")
                }}
                variant='text'
                endIcon={<KeyboardArrowDownIcon />}
              >
                  Show all
                </Button> </Box> : <Box sx={{
                  '& .MuiButton-endIcon>*:nth-of-type(1)': {
                    fontSize: '25px',
                  },
                  '& .MuiButton-endIcon': {
                    marginLeft: 0,
                  }
                }}> <Button
                  onClick={() => {
                    handleChangeShowAllFilters("region")
                  }}
                  variant='text'
                  endIcon={<KeyboardArrowUpIcon />}
                  sx={{ justifyContent: "left", fontSize: "14px", p: 0, whiteSpace: 'nowrap' }}
                >
                  Show less
                </Button></Box>)}


            {/* {regionTypes.length > 5 && (!showAll.region ? <span style={{ display: "flex !important", alignItems: "center" }} onClick={() => {
                handleChangeShowAllFilters("region")
              }}>Show all {regionTypes.length - 5}  <ArrowDownwardIcon /> </span>
                : <span onClick={() => {
                  handleChangeShowAllFilters("region")
                }}> Show less <ArrowUpwardIcon /></span>)} */}
            {/* </FormControl> */}
          </Box>
        </div>
        <div hidden={!holidayTypes?.length} >
          <Box mb="10px" border={{ lg: `1px solid ${colors.grey[30]}`, borderRadius: "10px", md: 'none' }} padding={"19px 24px 19px 24px"} bgcolor={colors.basics.white}>
            {/* <FormControl component='fieldset' variant='standard'> */}
            <Box display="flex" alignItems="center" mb="10px" flexDirection="row" justifyContent="space-between">
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="subtitle1" fontWeight={700} fontFamily={"Raleway"} fontSize={"16px"}>
                  Holiday Types
                </Typography>

                {/* Location Icon (same as screenshot) */}
                {/* <HolidayTypeSearchIcon /> */}
              </Box>

              {/* Arrow Icon (collapse/expand) */}
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                {openHoliday ? (
                  <ExpandLessIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenHoliday(false)} />
                ) : (
                  <ExpandMoreIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenHoliday(true)} />
                )}
              </Box>
            </Box>
            {openHoliday && <FormGroup
              sx={{
                display: 'flex',
                flexDirection: { md: 'col', xs: 'row' },
                alignItems: 'center',
                '& label': {
                  flex: { lg: '0 0 100%', sm: '0 0 48%', xs: '0 0 100%' },
                  alignItems: 'flex-start',
                },
                '& .MuiFormControlLabel-root .MuiFormControlLabel-label': {
                  mt: '2px !important',
                  fontSize: '14px !important',
                  lineHeight: '140% !important',
                },
                ml: '10px',
                '& .MuiButtonBase-root': {
                  padding: '0',
                  mr: '15px',
                  mb: '5px',
                }
              }}
            >
              {/* {holidayTypes?.slice(0, !showAll.hotels ? 5 : holidayTypes.length).map((place, index) => {
                  return <FormControlLabel
                    key={index}
                    control={<Checkbox name={place} />}
                    label={place.split('~')[1] + " (" + (filterCounts[place.split('~')[1]] || 0) + ")"}
                    value={place}
                    checked={filters.holidayType.includes(place)}
                    onChange={handleChangeHolidayTypeFilter}
                  />
                })} */}

              {holidayTypes?.slice(0, !showAll.hotels ? 5 : holidayTypes.length).map((place, index) => {
                return (filterCounts[place.split('~')[1]]) > 0 &&
                  <FormControlLabel
                    key={index}
                    control={<Checkbox name={place} sx={{
                      mr: "2px !important",   // reduces default right margin
                    }} />}
                    label={place.split('~')[1] + " (" + (filterCounts[place.split('~')[1]] || 0) + ")"}
                    value={place}
                    checked={filters.holidayType.includes(place)}
                    onChange={handleChangeHolidayTypeFilter}
                    sx={{ fontSize: '14px', fontWeight: '400', fontFamily: 'Raleway', gap: '5px', alignItems: 'center', }}
                  />
              })}
            </FormGroup>}

            {openHoliday && holidayTypes.length > 5 && (!showAll.hotels ? <Box sx={{
              '& .MuiButton-endIcon>*:nth-of-type(1)': {
                fontSize: '25px',
              },
              '& .MuiButton-endIcon': {
                marginLeft: 0,
              }

            }}> <Button
              sx={{ justifyContent: "left", fontSize: "14px", p: 0, whiteSpace: 'nowrap' }}
              onClick={() => {
                handleChangeShowAllFilters("hotels")
              }}
              variant='text'
              endIcon={<KeyboardArrowDownIcon />}
            >
                Show all
              </Button> </Box> : <Box sx={{
                '& .MuiButton-endIcon>*:nth-of-type(1)': {
                  fontSize: '25px',
                },
                '& .MuiButton-endIcon': {
                  marginLeft: 0,
                }
              }}> <Button
                onClick={() => {
                  handleChangeShowAllFilters("hotels")
                }}
                variant='text'
                endIcon={<KeyboardArrowUpIcon />}
                sx={{ justifyContent: "left", fontSize: "14px", p: 0, whiteSpace: 'nowrap' }}
              >
                Show less
              </Button></Box>)}

            {/* {holidayTypes.length > 5 && (!showAll.hotels ? <span onClick={() => {
                handleChangeShowAllFilters("hotels")
              }}>Show all {holidayTypes.length - 5}  <ArrowDownwardIcon /> </span> : <span onClick={() => {
                handleChangeShowAllFilters("hotels")
              }}> Show less <ArrowUpwardIcon /></span>)} */}

            {/* </FormControl> */}
          </Box>
        </div>
        {
          resultAvailableHotelRatings.length > 0 && (
            <>
              <Box mb="10px" border={{ lg: `1px solid ${colors.grey[30]}`, borderRadius: "10px", md: 'none' }} padding={"19px 24px 19px 24px"} bgcolor={colors.basics.white}>
                {/* <FormControl component='fieldset' variant='standard'> */}
                <Box display="flex" alignItems="center" mb="10px" flexDirection="row" justifyContent="space-between">
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="subtitle1" fontWeight={700} fontFamily={"Raleway"} fontSize={"16px"}>
                      Star Rating
                    </Typography>

                    {/* Location Icon (same as screenshot) */}
                    {/* <RatingStarSearchIcon /> */}
                  </Box>

                  {/* Arrow Icon (collapse/expand) */}
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    {openRating ? (
                      <ExpandLessIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenRating(false)} />
                    ) : (
                      <ExpandMoreIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenRating(true)} />
                    )}
                  </Box>
                </Box>

                {openRating && (<FormGroup
                  sx={{
                    ml: '10px',
                    '& .MuiButtonBase-root': {
                      p: 0,
                    },
                  }}
                >
                  {resultAvailableHotelRatings?.map((rating: any, i: number) => {
                    return rating > 0 && rating <= 5 ? (
                      <FormControlLabel
                        key={i}
                        control={<Checkbox sx={{
                          mr: "2px !important",   // reduces default right margin
                        }} />}
                        value={rating}
                        label={
                          <Box sx={{
                            alignItems: "center",
                            textAlign: { xs: "left", sm: "center" },
                            mt: { lg: 0, xs: "15px" },
                            "& .MuiRating-root .MuiRating-iconFilled": {
                              color: colors.basics.primary,
                            },
                            "& .MuiRating-iconHover": {
                              color: colors.basics.primary,
                            },
                          }}>
                            <Rating sx={{ fontSize: "16px" }} emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />} defaultValue={rating} precision={rating % 1 === 0 ? 1 : 0.5} readOnly={true} />
                          </Box>
                        }
                        checked={filters.starRating.includes(rating)}
                        onChange={(e) => {
                          // resultAvailableHotelRatings?.includes(String(rating)) && 
                          handleChangeRating(e);
                        }}
                        sx={{ gap: '5px', alignItems: 'center', }}
                      />
                    ) : null;
                  })}
                </FormGroup>)}
                {/* </FormControl> */}
              </Box>
            </>
          )
        }
        {/* <Box m='28px 0 23px' display={{ lg: 'block', xs: 'none' }}>
        <Typography variant='subtitle1' mb='10px'>
            Hotel Name
          </Typography>
          <SearchInput
            onSearchButtonClick={() =>
              dispatch(setFilterState({ ...filters, hotelName: hotelNameSearchText }))
            }
            onChange={handleHotelNameSearchChange}
            placeholder='Enter hotel name'
            // defaultValue={filters.hotelName}
            value={hotelNameSearchText}
          />
        </Box> */}
        {
          holidayPackage?.Packages?.results?.length > 1 &&
          <Box mb="10px" border={{ lg: `1px solid ${colors.grey[30]}`, borderRadius: "10px", md: 'none' }} padding={"19px 24px 19px 24px"} bgcolor={colors.basics.white}>
            <Box display="flex" alignItems="center" mb="10px" flexDirection="row" justifyContent="space-between">
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="subtitle1" fontWeight={700} fontFamily={"Raleway"} fontSize={"16px"}>
                  Price (per person)
                </Typography>

                {/* Location Icon (same as screenshot) */}
                {/* <MaxPriceSearchIcon /> */}
              </Box>

              {/* Arrow Icon (collapse/expand) */}
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                {openPrice ? (
                  <ExpandLessIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenPrice(false)} />
                ) : (
                  <ExpandMoreIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenPrice(true)} />
                )}
              </Box>
            </Box>
            {openPrice && (<>
              <Typography variant='body1' fontWeight={500} mb='9px' fontSize={"14px"} lineHeight={"140%"}>
                {signForPricing + pricePerPerson[0]} - {signForPricing + pricePerPerson[1]}
              </Typography>
              <Box>
                <Slider
                  onChangeCommitted={(event: React.SyntheticEvent | Event, val: any) => {
                    // if (holidayPackage.Packages.results > 0) {
                    dispatch(setFilterState({ ...filters, price: val }))
                    dispatch(setFindButtonClick(false))
                    // }
                  }}
                  valueLabelDisplay="off"
                  // height={5}
                  sx={{
                    height: "2px",
                    '& .MuiSlider-rail': {
                      color: colors.grey[50],
                    },
                    '& .MuiSlider-thumb': {
                      color: colors.basics.black,  //colors.grey[10],
                      width: 15,
                      height: 15,
                      backgroundColor: "white",     // dark outer circle
                      border: "4px solid",   // inner white center
                      boxShadow: "none",
                      "&:hover, &.Mui-focusVisible, &.Mui-active": {
                        boxShadow: "none",
                      },
                    },
                    '& .MuiSlider-track': {
                      color: colors.basics.black,// colors.grey[10],                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
                    },
                  }}
                  min={price?.low || 0}
                  max={price?.high || 10500}
                  value={pricePerPerson || 0}
                  onChange={(e, val: number | any) => {
                    // if (holidayPackage.Packages.results > 0) {
                    setPricePerPerson(val)
                    dispatch(setIsClickedFilters(true))
                    // }
                  }}
                />
              </Box>
            </>)}
          </Box>
        }
      </Box >
    </Box >
  );
};
